export default "__VITE_ASSET__tFlmODaA__"